export const modeTransfer = (chargingPriceData) => {
  if (chargingPriceData?.FixedPrice) return 'fixedRate'
  else if (chargingPriceData?.TimeOfUsePrice) return 'timeRate'
  else return ''
}

// 剛設定尖離峰費率，還沒設定尖峰時段 => 預設全天都是離峰
export const timeOfUsePriceDefault = (price) => {
  return ({
    Sunday: [{ BeginHour: 0, EndHour: 24, Price: price }],
    Monday: [{ BeginHour: 0, EndHour: 24, Price: price }],
    Tuesday: [{ BeginHour: 0, EndHour: 24, Price: price }],
    Wednesday: [{ BeginHour: 0, EndHour: 24, Price: price }],
    Thursday: [{ BeginHour: 0, EndHour: 24, Price: price }],
    Friday: [{ BeginHour: 0, EndHour: 24, Price: price }],
    Saturday: [{ BeginHour: 0, EndHour: 24, Price: price }]
  })
}

export const defaultPoserUsageData = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
export const defaultDoughnutStatusData = [0, 0, 0, 0, 0]
export const defaultDoughnutMaintenanceData = [0, 0]
